"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.auth = void 0;
require("reflect-metadata");
const toccata_1 = require("@musicaudienceexchange/toccata");
const app_1 = require("../app");
// eslint-disable-next-line @typescript-eslint/no-namespace
var auth;
(function (auth) {
    class SendLoginEmailRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsEmail()
    ], SendLoginEmailRequest.prototype, "email", void 0);
    __decorate([
        toccata_1.validator.IsUrl({
            protocols: ['http', 'https'],
            allow_underscores: true,
            require_tld: false,
        })
    ], SendLoginEmailRequest.prototype, "url", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], SendLoginEmailRequest.prototype, "shoutoutId", void 0);
    auth.SendLoginEmailRequest = SendLoginEmailRequest;
    class SendLoginEmailResponse extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.success = false;
        }
    }
    __decorate([
        toccata_1.validator.IsBoolean()
    ], SendLoginEmailResponse.prototype, "success", void 0);
    auth.SendLoginEmailResponse = SendLoginEmailResponse;
})(auth = exports.auth || (exports.auth = {}));
function init(fApp) {
    const functions = fApp ? fApp.functions() : app_1.app.firebase.functions();
    return {
        /**
         * Send a sign-in link to the requested email address.  If a user account
         * does not exist for the email address, this will still return
         * successfully.
         */
        sendLoginEmail: (0, toccata_1.createFunction)(functions, 'shoutout-sendLoginEmail', auth.SendLoginEmailRequest, auth.SendLoginEmailResponse),
    };
}
exports.init = init;
//export class Auth {
//  //private functions: firebase.functions.Functions;
//
//  constructor(functions?: firebase.functions.Functions) {
//    //functions = app.firebase.functions();
//  }
//
//  /**
//   * Send a sign-in link to the requested email address.  If a user account
//   * does not exist for the email address, this will still return
//   * successfully.
//   */
//  sendLoginEmail = createFunction(
//    app.firebase.functions(),
//    'shoutout_fan-sendLoginEmail',
//    auth.SendLoginEmailRequest,
//    auth.SendLoginEmailResponse
//  );
//}
//
//export default function (fApp?: firebase.app.App) {
//  const functions = fApp ? fApp.functions() : app.firebase.functions();
//
//  return {
//    /**
//     * Send a sign-in link to the requested email address.  If a user account
//     * does not exist for the email address, this will still return
//     * successfully.
//     */
//    sendLoginEmail: createFunction(
//      functions,
//      'shoutout_fan-sendLoginEmail',
//      auth.SendLoginEmailRequest,
//      auth.SendLoginEmailResponse
//    ),
//  };
//}
//# sourceMappingURL=auth.js.map